module.exports = __webpack_public_path__ + "img/FacebookBusiness.a5e18cbe.svg";